const elements = document.querySelectorAll('.animate-on-scroll');

// Observer for when the element reaches the center of the screen
const centerObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-active'); // Trigger center animation
    } else {
      entry.target.classList.remove('is-active'); // Remove center animation slightly before leaving
    }
  });
}, {
  root: null, // Viewport
  rootMargin: '-10% 0px -50% 0px', // Trigger at center, remove 10% before leaving
  threshold: 0, // Trigger as soon as the offset is met
});

elements.forEach((el) => {
  centerObserver.observe(el); // Observe for center trigger
});


document.addEventListener('scroll', function() {
    const productTimeline = document.querySelector('.product_timeline');
    const rect = productTimeline.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the vertical center of the element and the viewport
    const elementCenter = rect.top + rect.height / 2;
    const viewportCenter = windowHeight / 2;

    // Calculate the distance of the element's center to the viewport's center
    const distanceToCenter = Math.abs(elementCenter - viewportCenter);

    // Normalize this distance to a percentage of the viewport height
    const maxPossibleDistance = windowHeight / 2;
    const centerOffsetPercentage = (distanceToCenter / maxPossibleDistance) * 100;

    // Invert the percentage so that it is higher when the element is closer to the center
    const visibilityPercentage = 100 - centerOffsetPercentage;

    // Set clip-width as this inverted percentage
    productTimeline.style.setProperty('--clip-width', `${visibilityPercentage}%`);
});

function openIngreTab(el) {
  const ingre_tabs = document.querySelectorAll('.ingredient-tab')
  const ingre_content = document.querySelector('.product-ingeridents-content')
  ingre_tabs.forEach(tab => {
    if (tab == el)
      tab.classList.add('is-active')
    else
      tab.classList.remove('is-active')
  })
  ingre_content.innerText = el.getAttribute('data-content')
}